import { useCallback } from 'react';
import { ConditionItemType, FieldMeetCertainCriteriaType } from '../conditions/types';
import { useAutomationRuleConditions } from '../conditions/use-conditions';

export const useDatetimeInputWithConditions = () => {
	const {conditions, setConditions} = useAutomationRuleConditions();

	const onChangeDateTime = useCallback((conditionId: string) => (date: Date) => {
		setConditions(oldConditions => {
			const current = oldConditions.find(item => item.id === conditionId) as ConditionItemType;
			const others = oldConditions.filter(item => item.id !== conditionId);
			const fieldMeetACertainCriteriaValues = current.fieldMeetCertainCriteria as FieldMeetCertainCriteriaType;

			return [...others, {
				...current, fieldMeetCertainCriteria: {
					...fieldMeetACertainCriteriaValues,
					dateTimeValue: {
						...fieldMeetACertainCriteriaValues.dateTimeValue,
						type: 'datetime',
						datetime: {
							value: date,
						},
					}
				}
			}];
		});
	}, [conditions]);

	const onChangeTimeframe = useCallback((conditionId: string) => (timeframe: {
		timeNumber: number;
		timeUnit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
		timeOption: 'ago' | 'from-now';
	}) => {
		setConditions(oldConditions => {
			const current = oldConditions.find(item => item.id === conditionId) as ConditionItemType;
			const others = oldConditions.filter(item => item.id !== conditionId);
			const fieldMeetACertainCriteriaValues = current.fieldMeetCertainCriteria as FieldMeetCertainCriteriaType;

			return [...others, {
				...current, fieldMeetCertainCriteria: {
					...fieldMeetACertainCriteriaValues,
					dateTimeValue: {
						...fieldMeetACertainCriteriaValues.dateTimeValue,
						type: 'timeframe',
						timeframe: {
							...fieldMeetACertainCriteriaValues.dateTimeValue.timeframe,
							...timeframe,
						},
					}
				}
			}];
		});
	}, [conditions, setConditions]);

	return {
		onChangeDateTime,
		onChangeTimeframe,
	};
};